import { generateTestId } from "@client-shared";

export const setAnalyticsViewTestId = (identifier: string): string =>
  generateTestId("AnalyticsView", identifier);

// Container
export const setAnalyticsViewContainerTestId = (): string =>
  setAnalyticsViewTestId("container");

// Header elements
export const setAnalyticsViewTitleTestId = (): string =>
  setAnalyticsViewTestId("title");

export const setAnalyticsViewLast30DaysButtonTestId = (): string =>
  setAnalyticsViewTestId("last-30-days-button");

export const setAnalyticsViewExportReportButtonTestId = (): string =>
  setAnalyticsViewTestId("export-report-button");

// Chart grid
export const setAnalyticsViewChartGridTestId = (): string =>
  setAnalyticsViewTestId("chart-grid");
